export default __webpack_public_path__ + "static/media/gallery-3-1.e556abe9.webp";